export default {
      id: "helped-usage",
      viewBox: "0 0 35 28",
      url: __webpack_public_path__ + "app/svg/sprite.svg#helped",
      toString: function () {
        return this.url;
      }
    }